import { __rest as e } from "tslib";
import * as t from "react";
import a from "classnames";
import { ComponentClassNames as i } from "../shared/constants.js";
import { View as s } from "../View/View.js";
const m = {
    minX: 0,
    minY: 0,
    width: 24,
    height: 24
  },
  r = t.forwardRef((r, n) => {
    var {
        className: o,
        as: h = "svg",
        fill: l = "currentColor",
        pathData: c,
        viewBox: p = m,
        children: f,
        paths: d
      } = r,
      w = e(r, ["className", "as", "fill", "pathData", "viewBox", "children", "paths"]);
    const g = p.minX ? p.minX : m.minX,
      v = p.minY ? p.minY : m.minY,
      j = p.width ? p.width : m.width,
      x = p.height ? p.height : m.height;
    let N;
    return f && (N = f), d && (N = d.map((e, a) => t.createElement("path", Object.assign({}, e, {
      key: a
    })))), c && (N = t.createElement("path", {
      d: c,
      fill: l
    })), t.createElement(s, Object.assign({
      as: h,
      className: a(i.Icon, o),
      ref: n,
      viewBox: "".concat(g, " ").concat(v, " ").concat(j, " ").concat(x)
    }, w), N);
  });
r.displayName = "Icon";
export { r as Icon };